import { TRuleSources } from 'meta/rule_sources'

const rule_sources = {
  BATTLETOME_GLOOMSPITE_GITZ: {
    name: 'Battletome: Gloomspite Gitz (2023)',
    type: 'battletome',
  },
  GROTMAS_GITZ: {
    name: 'Games Workshop: Grotsmas Gitz',
    type: 'other_book',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2023/11/sRwk1m7XKIa5fjyQ.pdf',
  },
} satisfies TRuleSources

export default rule_sources
